var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loading"},[_c('app-card',[_c('header-context-consumer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_value = ref.value;
var headerTitle = ref_value.headerTitle;
var headerType = ref_value.headerType;
var headerShopName = ref_value.headerShopName;
var headerTotalPrice = ref_value.headerTotalPrice;
var headerTotalPriceUnit = ref_value.headerTotalPriceUnit;
return [_c('modal-header',{attrs:{"header-type":headerType,"shop-name":headerShopName,"total-price":headerTotalPrice,"total-price-unit":headerTotalPriceUnit,"title":headerTitle}})]}}])}),_c('div',{staticClass:"Loading_MainContainer"},[_c('wait-for-loading',{attrs:{"complete-duration":_vm.duration,"is-loading":_vm.isLoading,"completed":_vm.isCompleted},on:{"complete":_vm.onComplete}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }